// CreateApp.js
import { createApp, h } from 'vue';
import translatePlugin from '@/src/vue/plugins/translate.js';
import { Civet } from '@js/plugins/civet';

export function createVueApp (vueComponent, props) {
	const componentName = vueComponent.__name;
	const componentProps = props || js_params?.module?.[componentName] || {};

	const vueApp = createApp({ render: () => h(vueComponent, componentProps) });
	vueApp.use(translatePlugin);

	vueApp.config.errorHandler = (err, instance, info) => {
		const vueMeta = getVueInstanceMeta(instance, info);

		const error = err instanceof Error ? err : new Error(String(err));
		console.error(error);
		error.connectApiParameters = JSON.stringify({
			...(error.connectApiParameters || {}),
			vue: vueMeta
		});

		Civet.reportError(error);
	};
	return vueApp;
}

function getVueInstanceMeta (instance, info) {
	const i = instance?._ ?? instance; // support both shapes

	const type = i?.type ?? instance?.type;
	const component = type?.name || type?.__name || i?.vnode?.type?.name || i?.vnode?.type?.__name;
	// Props can exist in different spots depending on what you're holding
	const props = instance?.props ?? i?.props ?? i?.vnode?.props ?? instance?.proxy?.$props;

	return {
		info,
		component,
		props,
		uid: i?.uid ?? instance?.uid
	};
}
